'use client'
import React from 'react'
import { useState, useEffect } from 'react'
import { currencies } from '@constants'
import { getCookie } from 'cookies-next';


const CurrencySymbol = ({ lang = 'en' }) => {
    const [currencySymbol, setCurrencySymbol] = useState('฿');
    useEffect(() => {
        const savedCurrency = getCookie('currency');

        const matchedCurrency = currencies[lang].find(currency => currency.value === savedCurrency);

        if (matchedCurrency) {
            setCurrencySymbol(matchedCurrency.symbol);
        }
    });

    return (
        <span>{currencySymbol}</span>
    )
}

export default CurrencySymbol